import * as React from "react";
import Sms from "../../../../model/sms/Sms";
import IncomingSmsItem from "./IncomingSmsItem";

/**
 * SMS filter state.
 */
enum FilterState {
	All = "all",
	Recognized = "recognized",
	Unknown = "unknown"
}

interface IComponentProps {
	/**
	 * SMS list.
	 */
	messages: Array<Sms>
	/**
	 * Item click handler.
	 */
	onItemLinkClick: () => void;
	/**
	 * Dropdown open indicator.
	 */
	isOpen: boolean;
}

interface State {
	filter: FilterState
}

type Props = IComponentProps

export default class SmsCenterDropdown extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			filter: FilterState.All
		};
	}

	componentWillReceiveProps(nextProps: IComponentProps) {
		if (!nextProps.isOpen)
			this.setState({filter: FilterState.All});
	}

	render() {
		return (
			<React.Fragment>
				{this.renderFilter()}
				<div className={"c-sms-menu_dropdown_body"}>
					{this.renderTextMessages()}
				</div>
			</React.Fragment>
		);
	}

	/**
	 * Render filter menu.
	 * @returns {JSX.Element}
	 */
	renderFilter() {
		return (
			<div className="c-sms-menu_dropdown_header">
				<span className={this.state.filter === FilterState.All ? "active" : ""}
					  onClick={() => this.setFilter(FilterState.All)}>ALL</span>
				<span className={this.state.filter === FilterState.Recognized ? "active" : ""}
					  onClick={() => this.setFilter(FilterState.Recognized)}>RECOGNIZED</span>
				<span className={this.state.filter === FilterState.Unknown ? "active" : ""}
					  onClick={() => this.setFilter(FilterState.Unknown)}>UNKNOWN</span>
			</div>
		);
	}

	/**
	 * Set sms filter.
	 * @param filter
	 */
	setFilter(filter: FilterState) {
		this.setState({filter});
	}

	/**
	 * Render messages.
	 * @return {Array<JSX.Element>}
	 */
	renderTextMessages(): Array<JSX.Element> {
		const filtered = this.filterMessages();
		if (filtered.length) {
			return filtered.map((sms, index) =>
				<IncomingSmsItem key={index} sms={sms} onItemLinkClick={this.props.onItemLinkClick}/>
			)
		}
		else {
			return [
				<div className="c-sms-menu_dropdown_body_empty">
					<div>There are no incoming text messages</div>
				</div>
			];
		}
	}

	/**
	 * Filter messages by current selected filter.
	 * @returns {Sms[]}
	 */
	filterMessages(): Sms[] {
		switch (this.state.filter) {
			case FilterState.All:
				return this.props.messages;
			case FilterState.Recognized:
				return this.props.messages.filter(sms => sms.individualContact.isDefined)
			case FilterState.Unknown:
				return this.props.messages.filter(sms => sms.individualContact.isEmpty);
			default:
				return this.props.messages;
		}
	}
}